// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {PasswordRecoveryModuleLayout} from 'app_components/modules/passwordRecovery'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import AuthService from 'app_services/secure/auth/authService'
// @end

// @import types
import { IUserHttpResponse } from 'app_types/userTypes'
// @end

// @ADD Component types
interface IPasswordRecoveryModuleProps {
  onGoBack?: () => void
  onHandlePasswordRecover?: (userData: IUserHttpResponse) => void
}
interface IPasswordRecoveryModuleState {
  status: "loading" | "error" | null
  stage: number
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class PasswordRecoveryModule extends Component<IPasswordRecoveryModuleProps, IPasswordRecoveryModuleState> {

  private authService: AuthService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IPasswordRecoveryModuleProps) {
    super(props)
    this.state = {
      status: null,
      stage: 1
    }

    this.authService = new AuthService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {}

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  onSubmit = async (data: any) => {
    if (this.state.stage === 1) {
      this.setState({status: 'loading'})
      const passwordRecoveryResponse = await this.authService.passwordRecovery({
        destination: 'email',
        email: data.email
      })
      if (passwordRecoveryResponse && passwordRecoveryResponse.status === 'success') {
        this.setState({stage: 2})
      }
      this.setState({status: null})
    } else if (this.state.stage === 2) {
      this.setState({status: 'loading'})
      const changeRecoveredPasswordResponse = await this.authService.changeRecoveredPassword({
        token: data.code,
        password: data.password
      })
      if (changeRecoveredPasswordResponse && changeRecoveredPasswordResponse.status === 'success') {
        if (this.props.onHandlePasswordRecover) {
          this.props.onHandlePasswordRecover(changeRecoveredPasswordResponse)
        }
      }
      this.setState({status: null})
    }
  }

  render() {
    return(
      <PasswordRecoveryModuleLayout
        {...this.props}
        onSubmit={this.onSubmit}
        status={this.state.status}
        stage={this.state.stage}
      />
    )
  }
}

export default connect(mapStatesToProps)(PasswordRecoveryModule)
